import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw, Mail } from 'lucide-react';

const PaymentFail: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const errorCode = searchParams.get('error_code');
  const errorMessage = searchParams.get('error_message');

  // Hata mesajlarını Türkçeleştir
  const getErrorMessage = () => {
    if (errorMessage) {
      return decodeURIComponent(errorMessage);
    }
    
    switch (errorCode) {
      case 'insufficient_funds':
        return 'Yetersiz bakiye. Lütfen kartınızı kontrol edin.';
      case 'card_declined':
        return 'Kartınız reddedildi. Lütfen bankanızla iletişime geçin.';
      case 'expired_card':
        return 'Kart süresi dolmuş. Lütfen farklı bir kart kullanın.';
      case 'invalid_card':
        return 'Geçersiz kart bilgileri. Lütfen bilgileri kontrol edin.';
      case '3d_secure_failed':
        return '3D Secure doğrulaması başarısız oldu.';
      case 'timeout':
        return 'İşlem zaman aşımına uğradı. Lütfen tekrar deneyin.';
      default:
        return 'Ödeme işlemi tamamlanamadı. Lütfen tekrar deneyin.';
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Error Animation */}
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-red-500/20 rounded-full blur-3xl" />
          <div className="relative bg-red-500/10 p-8 rounded-full inline-block border border-red-500/30">
            <XCircle className="w-20 h-20 text-red-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-white mb-4">
          Ödeme Başarısız
        </h1>

        {/* Error Message */}
        <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4 mb-8">
          <p className="text-red-400">
            {getErrorMessage()}
          </p>
          {errorCode && (
            <p className="text-red-500/60 text-sm mt-2">
              Hata Kodu: {errorCode}
            </p>
          )}
        </div>

        {/* Suggestions */}
        <div className="bg-slate-900 rounded-xl p-6 mb-8 border border-slate-800 text-left">
          <h3 className="text-sm font-medium text-white mb-4">
            Ne Yapabilirsiniz?
          </h3>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400">•</span>
              Kart bilgilerinizi kontrol edin ve tekrar deneyin
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400">•</span>
              Farklı bir ödeme yöntemi kullanmayı deneyin
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400">•</span>
              Kartınızda yeterli bakiye olduğundan emin olun
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400">•</span>
              Bankanızla iletişime geçerek kartınızın online alışverişe açık olduğunu doğrulayın
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/subscription')}
            className="w-full py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-xl hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-5 h-5" />
            Tekrar Dene
          </button>

          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-4 bg-slate-800 text-white font-medium rounded-xl hover:bg-slate-700 transition-colors flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Dashboard'a Dön
          </button>
        </div>

        {/* Support Link */}
        <div className="mt-8 p-4 bg-slate-900/50 rounded-xl border border-slate-800">
          <p className="text-slate-400 text-sm mb-3">
            Sorun devam ediyorsa destek ekibimizle iletişime geçin
          </p>
          <a
            href="mailto:destek@avukasa.com"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
          >
            <Mail className="w-4 h-4" />
            destek@avukasa.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;

